module.exports = __webpack_public_path__ + "static/media/launchpool.c9a2ae6f.png";